<template>
  <v-snackbar :model-value="isShow" :color="notificationValue.mode">
    <span class="Notification body-2">
      {{ notificationValue.message }}
    </span>
    <v-btn variant="text" @click="close"> Close </v-btn>
  </v-snackbar>
</template>

<script lang="ts" src="./index.ts" />
<style lang="scss" src="./index.scss" scoped />
